<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Tips :dialogShow="dialogShow"></Tips>
  </div>
</template>
<script>
import Tips from "@/components/homePage/Tips.vue";
import { mapState } from "vuex";
export default {
  components: {
    // 底部
    Tips,
  },
  data() {
    return {
      dialogShow: false,
    };
  },
  created() {
    if (
      location.protocol !== "https:" &&
      location.hostname == "www.aixunliu.cn"
    ) {
      location.replace(`https://${location.hostname}${location.pathname}`);
    }
  },
  mounted() {
    this.disabledScale();
    if (this.$common.isSafari() && this.tipsShow) {
      this.dialogShow = true;
    }
  },
  computed: {
    ...mapState("perpetual", ["tipsShow"]),
  },
  watch: {
    $route: function (to, from) {
      window.scrollTo(0, 0);
    },
  },

  methods: {
    // 禁止ios10+页面缩放
    disabledScale() {
      var lastTouchEnd = 0;
      document.addEventListener("touchstart", function (event) {
        if (event.touches.length > 1) {
          event.preventDefault();
        }
      });
      document.addEventListener(
        "touchend",
        function (event) {
          var now = new Date().getTime();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        false
      );
      // 阻止双指放大
      document.addEventListener("gesturestart", function (event) {
        event.preventDefault();
      });
    },
  },
};
</script>

<style>
</style>
